import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { withHandlers } from 'recompose';

import { Link } from 'components/core/Link';

export const enhance = withHandlers({
	handlePageChange: (props) => () => {
		if (typeof props.onPageChange === 'function') {
			props.onPageChange(props.page);
		}
	}
});

export function PaginationItem({
	page,
	children,
	selected,
	disabled,
	handlePageChange,
}) {
	return (
		<li className={classNames('pagination-item', { selected, disabled })}>
			<Link
				hideBorder
				href={page.link}
				to={page.to}
				rel={page.nofollow ? 'nofollow' : null}
				onClick={handlePageChange}
				className="ph-link"
			>
				{children}
			</Link>
		</li>
	);
}

PaginationItem.propTypes = {
	page: PropTypes.shape({
		link: PropTypes.string,
		to: PropTypes.string,
		nofollow: PropTypes.bool
	}),
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	handlePageChange: PropTypes.func,
};

PaginationItem.defaultProps = {
	page: {}
};

export default enhance(PaginationItem);
